import {UserInfo} from './components/user-info';

export default {
    component: UserInfo
};
